function WfUnderConstruction() {
  return <div>WfUnderConstruction</div>;
}

export default WfUnderConstruction;
